import { defaultConfig } from 'app/config/environment';

/**
 * Normaliza una URL decodificando %2F a /
 * Necesario porque el backend a veces envía URLs con barras codificadas
 */
export function normalizeUrl(url) {
  if (!url || typeof url !== 'string') return url;
  return url.replace(/%2f/gi, '/');
}

export function getNameUrl(url) {
  if (url) {
    const replace = url.match(`http.+/`);
    return url.replace(replace, '');
  }

  return url;
}

export function openInNewTab(url) {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
}

export function openInNewTabRouter(PATH, guid, step) {
  // El paso es opcional en las rutas `/:step?`: sin él la ruta termina en el guid,
  // en lugar de arrastrar un segmento «undefined».
  const url = PATH.replace(':guid', guid).replace(/\/:step\??/, step === undefined || step === null ? '' : `/${step}`);

  openInNewTab(url);
}

export function getQueryString(string) {
  let queryString = string;
  const query = {};

  // Remove the question mark "?" from the beginning of the chain
  queryString = queryString.slice(1);

  // Separate key-value pairs using the "&" character
  const pares = queryString.split('&');

  // Separate each key and value using the "=" character
  for (const parItem of pares) {
    const par = parItem.split('=');
    const clave = par[0];
    const valor = par[1] ? decodeURIComponent(par[1].replace(/\+/g, ' ')) : '';

    // Assign keys and values to JavaScript object
    query[clave] = valor;
  }

  return query;
}

export function getDomainTenant({ tenant, user }) {
  const { BASE_URL_ } = defaultConfig;

  // TODO: Redireccionar al dominio de FrontOffice segun el pais, Ahora solo se haca para mx y EDELVIVES_DIGITAL_PLUS hay que buscar una solución generica.
  if (tenant?.tenant?.guid === 'EDELVIVES_DIGITAL_PLUS' && user?.country_guid === 'mx') {
    return BASE_URL_.includes('.mx') ? BASE_URL_ : `${BASE_URL_.slice(0, BASE_URL_.length - 1)}.mx/`;
  }
  // TODO: Redireccionar al dominio de FrontOffice segun el pais, Ahora solo se haca para mx y EDELVIVES_DIGITAL_PLUS hay que buscar una solución generica.
  if (tenant?.tenant?.guid === 'EDELVIVES_DIGITAL_PLUS' && BASE_URL_.includes('.mx')) {
    return BASE_URL_.replace('.mx', '');
  }

  if (tenant?.tenant?.guid === 'EDELVIVES_DIGITAL_PLUS' && BASE_URL_.includes('-dev')) {
    return BASE_URL_.replace('-dev', '-dev2');
  }

  if (tenant?.tenant?.guid === 'EDELVIVES_DIGITAL_PLUS' && BASE_URL_.includes('-qa')) {
    return BASE_URL_.replace('-qa', '-qa2');
  }

  return BASE_URL_;
}

export function getGUID(url) {
  if (url) {
    const regex = /\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/[^\/]+/;
    const match = url.match(regex);

    if (match) {
      return match[1];
    }
  }

  return '';
}

/**
 * Convierte una URL relativa de file-storage a una URL completa
 * @param {string} url - URL a convertir (puede ser relativa o completa)
 * @returns {string} - URL completa si es file-storage, o la URL original si ya es completa
 */
export function getFullFileStorageUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }

  // Si ya es una URL completa (empieza con http:// o https://), devolverla tal cual
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // Si la URL empieza con "/files-storage" o contiene "files-storage", construir la URL completa
  if (url.startsWith('/files-storage') || url.includes('files-storage')) {
    const { BASE_URL_ } = defaultConfig;
    return BASE_URL_ + (url.startsWith('/') ? url.substring(1) : url);
  }

  // Si no es file-storage, devolver la URL original
  return url;
}

/**
 * Añade un query param a una URL usando el separador correcto (`?` o `&`)
 * @param {string} url - URL base
 * @param {string} param - Param a añadir, p.ej. "auth=signed-url"
 * @returns {string} - URL con el param añadido
 */
export function appendQueryParam(url, param) {
  if (!url) return url;

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${param}`;
}
